import React from "react";
import {HtmlDisplay} from "../Display";
import {GridCell} from "../Grid";
import {inputType, notificationSuffix} from "./inputConstants";
import {Notification} from "./Notification";

interface CheckBoxItemProps {
    checked?: boolean;
    disabled?: boolean;
    hasTextField?: boolean;
    hideLabel?: boolean;
    label: string;
    labelClass?: string;
    name: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onChangeOther?: (value: string | boolean | undefined, otherValue: string) => void;
    value?: string | boolean;
    otherTextValue?: string;
    showLabel?: boolean;
}

export const CheckBoxItem: React.FC<CheckBoxItemProps> = ({
    checked = false,
    disabled,
    hasTextField,
    hideLabel,
    label,
    labelClass = "",
    name,
    onChange,
    onChangeOther,
    value,
    otherTextValue,
}) => {

    const otherTextInputName = `${name}_text`;
    const computedLabelClass = labelClass + (hideLabel ? " is-visuallyhidden " : "");

    return (
        <span className={`flex-container`}>
            <input
                aria-disabled={disabled}
                type={inputType.CHECKBOX}
                data-testid={name}
                readOnly={disabled}
                disabled={disabled}
                name={name}
                id={name}
                checked={checked}
                onChange={onChange}
                value={value as string}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label aria-disabled={disabled} className={computedLabelClass} htmlFor={name}>
        		<HtmlDisplay html={label} isInline/>
			</label>
            {
                hasTextField &&
                checked &&
                <>
                    <label className={`show-for-sr`} htmlFor={otherTextInputName}>{value}, requires additional
                        details</label>
                    <input
                        aria-disabled={disabled}
                        type={inputType.TEXT}
                        name={otherTextInputName}
                        data-testid={otherTextInputName}
                        id={otherTextInputName}
                        value={otherTextValue}
                        onChange={(event) => onChangeOther?.(value, event.target.value)}
                        readOnly={disabled}
                    />
                </>
            }
		</span>
    );
};

interface CheckBoxFieldProps extends CheckBoxItemProps {
    error?: string;
    helpText?: string;
    medium_columns?: string;
    [key: string]: unknown;
}

export const CheckBoxField: React.FC<CheckBoxFieldProps> = (props) => {
    const {error, name, label} = props;
    return (
        <GridCell
            aria-invalid={!!error}
            aria-errormessage={`${name}${notificationSuffix}`}
        >
            <CheckBoxItem {...props} />
            <Notification error={error} name={name} label={label}/>
        </GridCell>
    );
};
